import { NgModule } from '@angular/core';
import { ModelsListComponent } from './models-list/models-list.component';
import { SharedModule } from '../../shared/modules/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModelsComponent } from './models-add-upd/models-add-upd.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        ReactiveFormsModule
    ],
    exports: [],
    declarations: [
        ModelsListComponent,
        ModelsComponent
    ],
    providers: [],
})
export class ModelsModule { }
